goog.provide("shadow.js.shim.module$$mui$material$MenuItem");
goog.provide("module$shadow_js_shim_module$$mui$material$MenuItem");
shadow.js.shim.module$$mui$material$MenuItem = shadow.js.nativeProvides["@mui/material/MenuItem"] = shadow$bridge("@mui/material/MenuItem");
module$shadow_js_shim_module$$mui$material$MenuItem.default = shadow.js.shim.module$$mui$material$MenuItem;
